module.exports = __webpack_public_path__ + "static/media/hamburger.b71a0ec9.svg";